import { Currencies, PaymentRails, Networks, Tokens } from "./useTransfer";

export const OFFRAMP_SOURCE_NETWORKS = [
  Networks.ETHEREUM,
  Networks.POLYGON,
  Networks.SOLANA,
  Networks.BASE,
  Networks.TRON,
  Networks.ARBITRUM,
]

export const OFFRAMP_DEST_RAILS = [
  PaymentRails.UAEFTS,
  PaymentRails.INTERNATIONAL_WIRE,
  PaymentRails.SEPA,
  PaymentRails.ACH,
  PaymentRails.WIRE,
]

export const OFFRAMP_DEST_CURRENCIES_BY_RAILS: Record<PaymentRails.UAEFTS
  | PaymentRails.INTERNATIONAL_WIRE | PaymentRails.SEPA | PaymentRails.ACH | PaymentRails.WIRE, Currencies[]> = {
  [PaymentRails.UAEFTS]: [
    Currencies.AED
  ],
  [PaymentRails.INTERNATIONAL_WIRE]: [
    Currencies.USD
  ],
  [PaymentRails.SEPA]: [
    Currencies.EUR
  ],
  [PaymentRails.ACH]: [
    Currencies.USD
  ],
  [PaymentRails.WIRE]: [
    Currencies.USD
  ]
};

export const OFFRAMP_SOURCE_TOKENS_BY_NETWORK: Record<
  Networks.ETHEREUM | Networks.ARBITRUM | Networks.TRON | Networks.BASE | Networks.SOLANA | Networks.POLYGON, Tokens[]> = {
  [Networks.ETHEREUM]: [
    Tokens.USDC,
    Tokens.USDT,
  ],
  [Networks.POLYGON]: [
    Tokens.USDC,
    Tokens.USDT,
  ],
  [Networks.SOLANA]: [
    Tokens.USDC,
    Tokens.USDT,
  ],
  [Networks.BASE]: [
    Tokens.USDC,
  ],
  [Networks.TRON]: [
    Tokens.USDT,
  ],
  [Networks.ARBITRUM]: [
    Tokens.USDC,
  ],
} 